export const FORMAL_DAY_FORMAT ='dd/MM/yyyy'
export const MIN_LENGTH_FOR_SEARCH =2
export const MAX_INPUT_LENGTH =45
export const  USER_STORED_DATA ='logU'
